<template>
    <div class="cliente" app>
        <Navbar/>
        
        <v-content>
            <v-overlay
                absolute
                :value="loading"
                class="text-center"
            >
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-overlay>
            <v-row align="center" justify="center" style="padding: 16px 16px; margin-top: 30px">
                <v-col cols="12" sm="11" md="10">
                    <v-alert 
                        type="error"
                        :value="alert.length > 0"
                        :dark="customization.dark">
                        {{alert}}
                    </v-alert>
                    <v-card style="overflow-x:hidden" flat :dark="customization.dark">
                        <v-form :id="`gestaoProd_form`">
                            <h1 style="padding: 16px 16px">Criar Gestão de produção e SOS</h1>
                            <v-row 
                                align="center" 
                                justify="center" 
                                style="padding: 16px 16px"
                            >
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <Autocomplete
                                        :rules="requireRule"
                                        label="Placa"
                                        name="idveiculo"
                                        :dark="customization.dark"
                                        url="getVeiculo"
                                        :needWhere="true"
                                        iddisplay="placa"
                                        idvalue="idveiculo"
                                        outlined >
                                    </Autocomplete>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <v-text-field
                                        :rules="requireRule"
                                        label="Data"
                                        name="data"
                                        type="datetime-local"
                                        v-model="selecionado['data']"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <v-text-field
                                        :rules="requireRule"
                                        label="Latitude"
                                        name="latitude"
                                        v-model="selecionado['latitude']"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <v-text-field
                                        :rules="requireRule"
                                        label="Longitude"
                                        name="longitude"
                                        v-model="selecionado['longitude']"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <v-text-field
                                        label="Quantidade Carga"
                                        name="quantidade_carga"
                                        type="number"
                                        v-model="selecionado['quantidade_carga']"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <v-text-field
                                        label="Quantidade Descarga"
                                        name="quantidade_descarga"
                                        type="number"
                                        v-model="selecionado['quantidade_descarga']"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <Autocomplete
                                        label="Carga"
                                        name="idcarga"
                                        :dark="customization.dark"
                                        url="getCarga"
                                        :needWhere="true"
                                        iddisplay="descricao"
                                        idvalue="idcarga"
                                        outlined >
                                    </Autocomplete>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <Autocomplete
                                        label="Area"
                                        name="idlogponto"
                                        :dark="customization.dark"
                                        url="getLogPonto"
                                        :needWhere="true"
                                        iddisplay="nome"
                                        idvalue="idlogponto"
                                        outlined >
                                    </Autocomplete>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <Autocomplete
                                        label="Motorista"
                                        name="idmotorista"
                                        :dark="customization.dark"
                                        url="getMotorista"
                                        :needWhere="true"
                                        iddisplay="nome"
                                        idvalue="idmotorista"
                                        outlined >
                                    </Autocomplete>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <Autocomplete
                                        label="Situação"
                                        name="idsituacao"
                                        :dark="customization.dark"
                                        url="getSituacao"
                                        :needWhere="true"
                                        iddisplay="situacao"
                                        idvalue="idsituacao"
                                        outlined >
                                    </Autocomplete>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card>
                </v-col>
            </v-row>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                    fixed
                    dark
                    fab
                    right
                    color='red'
                    style="bottom: 85px"
                    v-on="on"
                    @click="back"
                    >
                        <v-icon>mdi-cancel</v-icon>
                    </v-btn>
                </template>
                <span>Cancelar</span>
            </v-tooltip>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                    fixed
                    dark
                    fab
                    right
                    color='green'
                    style="bottom: 15px"
                    v-on="on"
                    @click="salvar"
                    >
                        <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                </template>
                <span>Salvar</span>
            </v-tooltip>
        </v-content>
    </div>
</template>

<style scoped>

</style>

<script>
import Autocomplete     from '@/components/Autocomplete.vue';
import Navbar           from '@/components/Navbar.vue';
import api              from '@/plugins/apisauceHeader.js';
import router           from '@/router/index.js';

export default {
    name: 'Edit',
    components:{
        Navbar,
        Autocomplete
    },
    data(){
        return{
            id: null,
            requireRule: [
                r => (r && r.length > 0 ) || "Essa campo é obrigatório!"
            ],
            selecionado: {},
            alert: "",
            loading: false,
            customization: {},
            nameType: "",
            cols: []
        }
    },
    methods:{
        back(){
            router.push(`/Management`);
        },
        salvar(){
            const idveiculo = document.getElementsByName("idveiculo")[0].value != "" ? document.getElementsByName("idveiculo")[0].value : null;
            const idcarga = document.getElementsByName("idcarga")[0].value != "" ? document.getElementsByName("idcarga")[0].value : null;
            const idlogponto = document.getElementsByName("idlogponto")[0].value != "" ? document.getElementsByName("idlogponto")[0].value : null;
            const idsituacao = document.getElementsByName("idsituacao")[0].value != "" ? document.getElementsByName("idsituacao")[0].value : null;
            const idmotorista = document.getElementsByName("idmotorista")[0].value != "" ? document.getElementsByName("idmotorista")[0].value : null;

            if(!idveiculo){
                this.alert = "Campo placa precisa ser preenchido!";
                return;
            }
            if(!this.selecionado['data']){
                this.alert = "Campo data precisa ser preenchido!";
                return;
            }
            if(!this.selecionado['latitude']){
                this.alert = "Campo latitude precisa ser preenchido!";
                return;
            }
            if(!this.selecionado['longitude']){
                this.alert = "Campo longitude precisa ser preenchido!";
                return;
            }
            if(!idmotorista){
                this.alert = "Campo motorista precisa ser preenchido!";
                return;
            }


            this.loading = true;
            api(localStorage.getItem("token")).post(`endpoint/gestao_prod`,
                {
                    data: this.selecionado['data'],
                    latitude: this.selecionado['latitude'],
                    longitude: this.selecionado['longitude'],
                    idveiculo,
                    idlogponto,
                    idcarga,
                    quantidade_carga: this.selecionado['quantidade_carga'] != "" ? this.selecionado['quantidade_carga'] : 0,
                    quantidade_descarga: this.selecionado['quantidade_descarga'] != "" ? this.selecionado['quantidade_descarga'] : 0,
                    idsituacao,
                    idmotorista
                }
            ).then(r=>{
                if(r.ok)
                    router.push(`/Management`);
                else 
                    this.alert = r.data;
                this.loading = false;
            })
        },
        getDate(date){
            const data = new Date(date);
            const getZeroLeft = (n) =>{
                return n <= 9 ? `0${n}` : n;
            }
            return `${getZeroLeft(data.getDay())}/${getZeroLeft(data.getMonth() + 1)}/${data.getFullYear()} ${getZeroLeft(data.getHours())}:${getZeroLeft(data.getMinutes())}:${getZeroLeft(data.getSeconds())}`;
        }
    },
    mounted(){
        this.customization  = JSON.parse(localStorage.getItem("customization"));
        this.id             = this.$route.params.id;
        document.title      = `${this.customization.name} - Editar Gestão de Produção e SOS`;
        if(!localStorage.getItem("usrId")) router.push('/');
    }
}
</script>